import React from 'react';
import PropTypes from 'prop-types';
import { Box, Chip } from '@mui/material';
import { FILE_TYPE_FILTERS } from './fileType';

export default function FileTypeFilter({ value, onChange }) {
  return (
    <Box sx={{ display: 'flex', gap: 1, mb: 2, flexWrap: 'wrap' }}>
      {FILE_TYPE_FILTERS.map((filter) => (
        <Chip
          key={filter.value}
          label={filter.label}
          color={value === filter.value ? 'primary' : 'default'}
          variant={value === filter.value ? 'filled' : 'outlined'}
          onClick={() => onChange(filter.value)}
        />
      ))}
    </Box>
  );
}

FileTypeFilter.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
